import { requestREST } from "~/client/http/CommonHTTP";
import { NetworkResponse } from "~/app/type/common";
import {
  DirectionsPostSchema,
  DirectionsSchema,
  DirectionsPutSchema,
  DirectionsResponse,
  IParamsDirections,
} from "~/entity/Directions";

const directionsServiceMap = {
  getDirections: "/directions",
};

export class DirectionsService {
  static GET = {
    getDirections: (
      params: IParamsDirections
    ): NetworkResponse<DirectionsSchema> =>
      requestREST.get(directionsServiceMap.getDirections, { params }),
  };

  static POST = {
    createDirections: (
      data: DirectionsPostSchema
    ): NetworkResponse<DirectionsSchema> =>
      requestREST.post(directionsServiceMap.getDirections, data),
  };

  static PUT = {
    putDirections: (
      data: DirectionsPutSchema
    ): NetworkResponse<DirectionsSchema> =>
      requestREST.put(directionsServiceMap.getDirections, data),
  };
  static DELETE = {
    deleteDitection: (instanceId: number): NetworkResponse<DirectionsSchema> =>
      requestREST.delete(directionsServiceMap.getDirections, {
        params: { instanceId },
      }),
  };
}
